import styled from 'styled-components';
import {
  DataModelerTabPanel,
  verticalWrapperStyles,
} from '../DataModelerCommonUI';

export const ConfigurationForm = styled(DataModelerTabPanel)`
  width: 100%;
  ${verticalWrapperStyles};
`;

export const ConfigurationColsWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, minmax(240px, 1fr));
  column-gap: 16px;
`;

export const ConfigurationRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const LongNameWrapper = styled.div`
  max-width: 100px;
  font-weight: 600;
`;
